import React, {createContext, useContext, useState, useCallback} from "react";
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "./StoryUIHelpers";
import { shallowEqual, useSelector } from "react-redux";

const StoryUIContext = createContext();

export function useStoryUIContext() {
  return useContext(StoryUIContext);
}

export const StoryUIConsumer = StoryUIContext.Consumer;

export function StoryUIProvider({storyUIEvents, children}) {
  const { filters } = useSelector((state) => state.story, shallowEqual);

  const [queryParams, setQueryParamsBase] = useState(filters);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initStory = {
    id: undefined,
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    gender: "Female",
    status: 0,
    dateOfBbirth: "",
    ipAddress: "",
    type: 1
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initStory,
    newStoryButtonClick: storyUIEvents.newStoryButtonClick,
    openEditStory: storyUIEvents.openEditStory,
  };

  return <StoryUIContext.Provider value={value}>{children}</StoryUIContext.Provider>;
}